import { ApolloProvider } from '@apollo/client';
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { AuthProvider } from '../infrastructure/context/AuthContext';
import { DemoConfigProvider } from '../infrastructure/context/DemoConfigContext';
import { NotificationsProvider } from '../infrastructure/context/NotificationsContext';
import apolloClient from '../infrastructure/persistence/graphql';
import theme from '../infrastructure/theme';
import Router from './routing/Router';

const App: React.FC = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <DemoConfigProvider>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <SnackbarProvider maxSnack={5}>
                <NotificationsProvider>
                  <CssBaseline />
                  <Router />
                </NotificationsProvider>
              </SnackbarProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </DemoConfigProvider>
      </AuthProvider>
    </ApolloProvider>
  );
};

export default App;
